module.exports = __webpack_public_path__ + "img/civilAffairs.2c1bc4d0.png";